import React from 'react'
import asyncComponent from '../../../components/commons/AsyncComponent'
import {Switch, Route,Redirect } from 'react-router-dom'
import LoadableComponent from "../../../components/LoadableComponent";

const Main = asyncComponent(() => import('../../../components/Layout/Main'))
const Manual = asyncComponent(() => import('../manual/Index/index'))
const WebIndex = asyncComponent(() => import('../web/Index/index'))
const contentPrint = asyncComponent(() => import('../web/maintain/PrintContent/views/Print'))
const ToolTimeManual = asyncComponent(() => import('../toolTimeManual/Index/index'))
const TbIndex = asyncComponent(() => import('../technicalBriefing/Index'))
const Article = asyncComponent(() => import('../technicalBriefing/TBArticle'))
const HomePage = asyncComponent(() => import('../homePage/Index/index'))
const eAtlas = asyncComponent(() => import('../eAtlas/Index/index'))
const spareHomePage = asyncComponent(() => import('../../SparepartHomePage'))
const eAtlasPdf = asyncComponent(() => import('../eAtlas/EAtalsContent/views/PDF'))
const KeyIndex = asyncComponent(() => import('../keyCipher/Index/index'))
const bigPic = asyncComponent(() => import('../eAtlas/EAtalsBigPic/BigPic'))
const Products = asyncComponent(() => import('../products/Index/index'))
const hotPoint = asyncComponent(() => import('../../../Backend/dongfeng/HotPoint/index'))
const verification = asyncComponent(() => import('../../../Backend/dongfeng/Verification/index'))
const FdIndex = asyncComponent(() => import('../faultDiagnosis/Index/demoIndex'))
const Toolkit = asyncComponent(() => import('../toolkit/Index/index'))
const Answer = asyncComponent(() => import('../AnswerCenter'))
const VehicleDepartmentsQueryZCYS = asyncComponent(() => import('../../frontZCYS/VehicleDepartmentsQuery'))
const VehicleDepartmentsQueryZCYSDetail = asyncComponent(() => import('../../frontZCYS/VehicleDepartmentsQuery/views/Detail/List'))
const Journalism = asyncComponent(() => import('../../dongfeng/Journalism/views/News'))
const OverseasDetail = asyncComponent(() => import('../../frontZCYS/OverseasCustomization/views/Detail/List'))
const Overseas = asyncComponent(() => import('../../frontZCYS/OverseasCustomization/index'))

const YiJing = asyncComponent(() => import('../../yijing/SparepartHomePage'))

class FrontendIndex extends React.Component {
    render() {
        return (
            <div>
                <Switch>
                    {/*/!* 奕境首页重定向，加 exact 精确匹配，只访问纯 /dmsCustomization 才跳转 *!/*/}
                    <Route exact path="/dmsCustomization">
                        <Redirect to="/dmsCustomization/zh/vehicleDepartmentsQuery" />
                    </Route>
                    {/* 奕境页面实际路由（多语言页面，放在重定向下方） */}
                    {/*<Route path="/dmsCustomization/:lang/vehicleDepartmentsQuery" component={YiJing}/>*/}
                    <Route path="/dmsCustomization" component={YiJing}/>{/*奕境*/}

                    <Route path="/sPage" component={VehicleDepartmentsQueryZCYS}/>{/*国内中车云商*/}
                    <Route path="/home_vehicleDepartmentsQuery/sPage/detail" component={VehicleDepartmentsQueryZCYSDetail}/>{/*国内中车云商*/}
                    <Route path="/gbs/:locales/journalism/news/:value/:id" component={Journalism}/>{/*海外新闻详情页面*/}
                    <Route path="/gbs/:locales/detail/" component={OverseasDetail}/>{/*海外目录页面*/}
                    <Route path="/gbs" component={Overseas}/>{/*海外*/}
                    <Route path="/verification/:id" component={verification}/>{/*目录验证*/}
                    <Route path="/hotPoint/:id" component={hotPoint}/>{/*热点维护*/}
                    <Route path="/seePic/:id/:index/:imgIndex" component={bigPic}/>{/*电路图册原图*/}
                    <Route path="/contentPrint/:directoryId" component={contentPrint}/>{/*维修手册打印*/}
                    <Route path="/content/:contentId" component={Article}/>{/*简报及快讯打印*/}
                    <Route path="/eAtlas/pdf/:pdfUrl/:pdfName" component={eAtlasPdf}/>{/*电路图册查看pdf*/}
                    <Route path="/eAtlas" component={eAtlas}/>{/*电路图册*/}
                    <Route path="/technicalBriefing" component={TbIndex}/>{/*技术简报*/}
                    <Route path="/faultDiagnosis" component={FdIndex}/>{/*故障诊断*/}
                    <Route path="/key" component={KeyIndex}/>{/*钥匙密码*/}
                    <Route path="/web" component={WebIndex}/>{/*维修手册*/}
                    <Route path="/toolManual" component={Toolkit}/>{/*工具手册*/}
                    <Route path="/toolTimeManual" component={ToolTimeManual}/>{/*工时手册*/}
                    <Route path="/manual" component={Manual}/>{/*使用手册*/}
                    <Route path="/main" component={Main}/>{/*目录验证*/}
                    <Route path="/Answer" component={Answer}/>{/*答疑平台*/}
                    <Route path="/products" component={Products}/>{/*精品*/}
                    <Route path="/home_vehicleDepartmentsQuery" component={spareHomePage}/>{/*备件目录*/}
                    <Route path="/" component={spareHomePage}/>{/*根目录，首页*/}
                    {/*<Route path="/" component={HomePage}/>/!*根目录，首页*!/*/}
                </Switch>
            </div>
        )
    }
}

export default FrontendIndex


// WEBPACK FOOTER //
// ./src/project/dongfeng/FrontendIndex/index.js